// @flow

import mediatorChannels from "@tvg/mediator";
import { get } from "lodash";
import pushToDataLayer from "../gtmUtils";

type MyBetsGTMEventsType =
  | "MYBETS_EMPTY_MESSAGE"
  | "MYBETS_MODAL_CLOSE_FDR"
  | "MYBETS_CONFIRM_DELETE_BET_FDR"
  | "MYBETS_TAB_SELECT_FDR"
  | "MYBETS_OPEN_FROM_FOOTER_FDR"
  | "RACE_ACTIVE_BETS_MODAL_CLOSE"
  | "RACE_ACTIVE_BETS_MODAL_OPEN";

type MyBetsEmptyMessage = {
  type: MyBetsGTMEventsType,
  payload: {
    buttonText: string,
    module: string,
    destinationUrl: string
  }
};

type MyBetsTabSelect = {
  type: MyBetsGTMEventsType,
  payload: {
    selectedTab: string,
    activeTab: string
  }
};

export default () => {
  mediatorChannels.base.subscribe(
    "MYBETS_TAB_SELECT_FDR",
    (data: MyBetsTabSelect) => {
      pushToDataLayer({
        event: "siteClick",
        gaEventCategory: "site click",
        gaEventAction: "open",
        tag: undefined,
        gaEventLabel: get(data, "payload.selectedTab"),
        module: get(data, "payload.activeTab")
      });
    }
  );

  mediatorChannels.base.subscribe("MYBETS_MODAL_CLOSE_FDR", () => {
    pushToDataLayer({
      event: "siteClick",
      gaEventCategory: "site click",
      gaEventAction: "close",
      tag: undefined,
      gaEventLabel: "bets",
      module: "bets"
    });
  });

  mediatorChannels.base.subscribe("MYBETS_CONFIRM_DELETE_BET_FDR", () => {
    pushToDataLayer({
      event: "siteClick",
      gaEventCategory: "site click",
      gaEventAction: "deleted",
      gaEventLabel: "bet",
      module: "upcoming bets",
      tag: undefined
    });
  });

  mediatorChannels.base.subscribe(
    "MYBETS_EMPTY_MESSAGE",
    (data: MyBetsEmptyMessage) => {
      pushToDataLayer({
        event: "navigation",
        gaEventCategory: "navigation",
        gaEventAction: "navigated to",
        gaEventLabel: data.payload.buttonText,
        module: data.payload.module,
        tag: undefined,
        destinationUrl: data.payload.destinationUrl
      });
    }
  );

  mediatorChannels.base.subscribe("MYBETS_OPEN_FROM_FOOTER_FDR", () => {
    pushToDataLayer({
      event: "siteClick",
      gaEventCategory: "site click",
      gaEventAction: "open",
      tag: undefined,
      gaEventLabel: "bets",
      module: "mobile footer"
    });
  });

  mediatorChannels.base.subscribe(
    "MYBETS_OPEN_LIVE_VIDEO",
    (data: { tag: string, raceUrl: string }) => {
      pushToDataLayer({
        event: "navigation",
        gaEventCategory: "Navigation",
        gaEventAction: "Navigated To",
        gaEventLabel: "watch",
        module: "bets page",
        tag: get(data, "payload.tag"),
        menu: undefined,
        sport: "Horse Racing", // e.g. 'Horse Racing' or 'Greyhounds Racing'
        destinationUrl: get(data, "payload.raceUrl")
      });
    }
  );

  mediatorChannels.base.subscribe("RACE_ACTIVE_BETS_MODAL_OPEN", () => {
    pushToDataLayer({
      event: "siteClick",
      gaEventAction: "Open",
      gaEventCategory: "Site Click",
      gaEventLabel: "Race Active Bets",
      tag: undefined,
      module: "racecard"
    });
  });

  mediatorChannels.base.subscribe("RACE_ACTIVE_BETS_MODAL_CLOSE", () => {
    pushToDataLayer({
      event: "siteClick",
      gaEventCategory: "site click",
      gaEventAction: "close",
      tag: undefined,
      gaEventLabel: "Race Active Bets",
      module: "Race Active Bets"
    });
  });

  mediatorChannels.base.subscribe("RACE_ACTIVE_BETS_MODAL_RETURN", (data) => {
    const eventLabel = `${get(data, "payload.trackName")} - R${get(
      data,
      "payload.raceNumber"
    )} - ${get(data, "payload.mtp")}`;
    pushToDataLayer({
      event: "Navigation",
      gaEventAction: "Navigated to",
      gaEventCategory: "Navigation",
      gaEventLabel: eventLabel,
      module: "Race Active Bets",
      microApp: "non-Microapp"
    });
  });
};
